import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import closeIcon from "../../../common/assets/images/x-close.png";
import debounce from "lodash.debounce";
import {
  updateUserAssginedFilters,
  fetchCodersData,
  // resetEpisodeIdsCoderData,
  getQueueFilterOptions,
  setQueueFilterSearch,
  resetCoderFilters,
  getCoderViewCards,
  fetchStatsData,
  getCoderSidebarQueues,
  resetFilterQueue,
} from "./redux/CoderScreenSlice";

import {
  updateFilters,
  setProvisionalDrgFilterSearch,
  getEpisodeIdentiferFilterOptions,
  getMRNFilterOptions,
  getSpecialityFilterOptions,
  getCoderFilterOptions,
  getPriorityFilterOptions,
  getStatusFilterOptions,
  getHealthFundContractFilterOptions,
  getProvisionalDrgFilterOptions,
  setMRNFilterSearch,
  setSpecialityFilterSearch,
  setEpisodeIdentiferFilterSearch,
  resetFilterByKey,
  setCoderFilterSearch,
  setPriorityFilterSearch,
  setHealthFundFilterContractSearch,
  setStatusFilterSearch,
} from "../HealthInsuranceManager/redux/HealthInformationManagerSlicer";

import "./CoderFilterModal.css";
import MultiSelect from "../../../utils/MultiSelect";

const CoderFilterModal = ({
  show,
  setShowCoderFilter,
  onClose,
  losOperator,
  setLosOperator,
  losValue,
  setLosValue,
  isLosEnabled,
  setIsLosEnabled,
  setCoderSearchTerm
}) => {
  const dispatch = useDispatch();
  const {
    episodeIdentiferFilterOptions,
    MRNFilterOptions,
    specialityFilterOptions,
    priorityFilterOptions,
    statusFilterOptions,
    healthFundContractFilterOptions,
    provisionalDrgFilterOptions,
  } = useSelector((state) => state.healthInsuranceManager);

  /* =========================
     REDUX STATE
  ========================= */
  const filtersPayload = useSelector(
    (state) => state.coderscreenqueue.coderFilter,
  );

  const {
    queueFilterOptions
  } = useSelector((state) => state.coderscreenqueue);

   const labelCache = useRef({
      speciality: {},
      queue: {},
      status: {},
    });

  const [losToValue, setLosToValue] = useState("");
  const [losMode, setLosMode] = useState("single");
  const [isCodeEnhanceSelected, setIsCodeEnhanceSelected] = useState(false);
  const [firstQueueTypeWhenUnassigned, setFirstQueueTypeWhenUnassigned] =
    useState(null);

  const episodeIdentiferFieldOptions = useMemo(() => {
    const apiOptions = (episodeIdentiferFilterOptions.data || []).map(
      (item) => ({
        label: item,
        value: item,
      }),
    );

    const episode_identifier = [].concat(
      filtersPayload?.episode_identifier || [],
    );

    const selectedOptions = episode_identifier.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [episodeIdentiferFilterOptions.data, filtersPayload?.episode_identifier]);

  const MRNFieldOptions = useMemo(() => {
    const apiOptions = (MRNFilterOptions.data || []).map((item) => ({
      label: item,
      value: item,
    }));

    const medical_record_number = [].concat(filtersPayload?.medical_record_number || []);

    const selectedOptions = medical_record_number.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [MRNFilterOptions.data, filtersPayload?.medical_record_number]);

  const specialityFieldOptions = useMemo(() => {
    const apiOptions = (specialityFilterOptions?.data || []).map((item) => {
        labelCache.current.speciality[item.hospital_speciality_id] =
          item.speciality;

        return {
        label: item.speciality,
        value: item.hospital_speciality_id,
      };
    });

    const speciality = [].concat(filtersPayload?.speciality || []);

    const selectedOptions = (speciality || []).map(
        (value) => ({
          value,
          label: labelCache.current.speciality[value] || value,
        }),
      );

    // merge selected + api options (avoid duplicates)
    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [specialityFilterOptions.data, filtersPayload.speciality]);

  const queueFieldOptions = useMemo(() => {
    const apiOptions = (queueFilterOptions.data || []).map((item) => {
      labelCache.current.queue[item.queue_id] = item.queue_name;

      return {
        label: item.queue_name,
        value: item.queue_id,
      };
    });

    const selectedOptions = (filtersPayload.queue || []).map((value) => ({
      value,
      label: labelCache.current.queue[value] || value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [queueFilterOptions.data, filtersPayload.queue]);

  const priorityFiledOptions = useMemo(() => {
    const apiOptions = priorityFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const priority = [].concat(filtersPayload?.priority || []);
    const selectedOptions = priority?.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [priorityFilterOptions.data, filtersPayload?.priority]);

  // const statusFiledOptions = useMemo(() => {
  //   const apiOptions = statusFilterOptions.data.map((item) => ({
  //     label: item.status,
  //     value: item.status_id,
  //   }));

  //   const status = [].concat(filtersPayload?.status || []);


  //   const selectedOptions = status?.map((value) => ({
  //     label: value,
  //     value: value,
  //   }));

  //   const map = new Map();

  //   [...selectedOptions, ...apiOptions].forEach((item) => {
  //     map.set(item.value, item);
  //   });

  //   return Array.from(map.values());
  // }, [statusFilterOptions.data, filtersPayload?.status]);
  const statusLabelCache = useRef({});
  const statusFiledOptions = useMemo(() => {
    const apiOptions = (statusFilterOptions.data || []).map((item) => {
      // ✅ store label in cache
      labelCache.current.status[item.status_id] = item.status;

      return {
        label: item.status,
        value: item.status_id,
      };
    });

    const selectedOptions = (filtersPayload?.status || []).map((value) => {
      return {
        value,
        label: labelCache.current.status[value] || value,
      };
    });

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [statusFilterOptions.data, filtersPayload?.status]);
  const healthFundFieldOptions = useMemo(() => {
    const apiOptions = healthFundContractFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.health_fund_contract?.map(
      (value) => ({
        label: value,
        value: value,
      }),
    );

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    healthFundContractFilterOptions.data,
    filtersPayload?.health_fund_contract,
  ]);

  const provisionalDrgFieldOptions = useMemo(() => {
    const apiOptions = provisionalDrgFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.drg_code?.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [provisionalDrgFilterOptions.data, filtersPayload?.drg_code]);

  /* =========================
   LOS OPERATOR OPTIONS
========================= */
const losOperatorOptions = [
  { label: ">", value: "gt" },
  { label: "<", value: "lt" },
  { label: ">=", value: "gte" },
  { label: "<=", value: "lte" },
  { label: "=", value: "eq" },
  { label: "!=", value: "neq" },
  { label: "Between", value: "gtlt" },
  { label: "Between (Inclusive)", value: "gtelte" },
];

const losOpLabelMap = {
  gt: ">",
  lt: "<",
  gte: ">=",
  lte: "<=",
  eq: "=",
  neq: "!=",
  gtlt: "Between",
  gtelte: "Between (Inclusive)",
};

  const debouncedSearchRef = useRef(
    debounce((thunk, value) => {
      dispatch(
        thunk({
          search: value || "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }, 1000),
  );

  const handleInputChange =
    (setSearchAction, fetchThunk) =>
    (value, { action }) => {
      if (action !== "input-change") {
        return;
      }
      dispatch(setSearchAction(value || ""));
      debouncedSearchRef.current(fetchThunk, value);
    };

  const handleScrollBottom = (options, thunk) => () => {
    if (options.hasMore && !options.loading) {
      dispatch(
        thunk({
          search: options.search || "",
          page_number: options.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnFocus = (optionsState, fetchThunk) => {
    if (optionsState?.data?.length === 0 && !optionsState.loading) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnChange = async ({
    key,
    selected,
    optionsState,
    fetchThunk,
    searchResetAction,
    minVisible = 4,
  }) => {
    const selectedArray = selected || [];

    const selectedValues =
      key === "queue" || key === "speciality" || key === "status"
        ? selectedArray.map((s) => s.value)
        : selectedArray.map((s) => s.label);


    const finalValues = selectedValues
    // dispatch(updateFilters({ [key]: selectedValues }));
    dispatch(updateUserAssginedFilters({ 
      ...filtersPayload,
      [key]: finalValues
     }));

    if (optionsState.search) {
      dispatch(searchResetAction(""));
      debouncedSearchRef.current?.cancel?.();

      let currentPage = 1;
      let hasMore = true;
      let accumulatedData = [];

      while (hasMore) {
        const response = await dispatch(
          fetchThunk({
            search: "",
            page_number: currentPage,
            page_size: 10,
          }),
        ).unwrap();

        const dataMap = {
          episode_identifier: response.episode_identifier_number,
          medical_record_number: response.medical_record_number,
          speciality: response?.specialities,
          queue: response?.queues?.data,
          priority: response?.priority,
          status: response?.status,
          health_funds: response?.health_funds,
          drg_code: response?.drg_codes,
        };

        const pageData = dataMap[key] || [];
        accumulatedData = [...accumulatedData, ...pageData];
        hasMore = response.has_more;
        console.log(pageData, "pageData");
        const visibleOptions = accumulatedData.filter((item) => {
          const compareValue =
            key === "queue" || key === "speciality" || key === "status" ? item.value : item;

          return !selectedValues.includes(compareValue);
        });



        if (visibleOptions.length >= minVisible) break;
        if (!hasMore) break;

        currentPage += 1;
      }
      return;
    }
    const visibleOptions = optionsState.data.filter((item) => {
      let compareValue;
      if (typeof item === "object") {
        if (key === "speciality") {
          compareValue = item.hospital_speciality_id;
        } else if (key === "queue") {
          compareValue = item.queue_id;
        } else if (key === "status") {
          compareValue = item.status_id;
        } else {
          compareValue = item.value || item.label;
        }
      } else {
        compareValue = item;
      }

      return !selectedValues.includes(compareValue);
    });

    if (
      visibleOptions.length < minVisible &&
      optionsState.hasMore &&
      !optionsState.loading
    ) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: optionsState.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

    const handleResetOnBlur = (stateKey, searchResetAction) => () => {
        debouncedSearchRef.current?.cancel?.();
        dispatch(searchResetAction(""));
        if (stateKey === "queueFilterOptions") {
          dispatch(resetFilterQueue(stateKey));
        } else {
          dispatch(resetFilterByKey(stateKey));
        }
      };

  // const { mrn } = useSelector((state) => state.coderscreenqueue);

  // const { mrnData, isMrnPageTrue, mrnPageNumber } = mrn;

  // UI-only state for unassigned (not in Redux/API)
  const [unassigned, setUnassigned] = useState(false);

  const isUserSpecific = filtersPayload.is_user_specific ?? true;
  const isQueueDisabled = isUserSpecific === true;

  const LIMITED_STATUS = ["Outstanding", "AI codes awaiting validation"];

  /* =========================
     OPTIONS MAPPING
  ========================= */

  const filteredStatusOptions =
  isUserSpecific === false
    ? statusFiledOptions.filter((s) =>
        LIMITED_STATUS.includes(s.label)
      )
    : statusFiledOptions;

  const userSpecificOptions = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];

  /* =========================
     FETCH OPTIONS ON OPEN
  ========================= */
  useEffect(() => {

    if (show) {
      // dispatch(resetCoderFilters());
      dispatch(
        getEpisodeIdentiferFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );

      dispatch(
        getMRNFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );

      dispatch(
        getSpecialityFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getQueueFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getCoderFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getPriorityFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getStatusFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getHealthFundContractFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getProvisionalDrgFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      // Reset LOS state when modal opens
      if (filtersPayload.los_op) {
        setLosOperator(filtersPayload.los_op);
        setIsLosEnabled(true);
        if (
          filtersPayload.los_op === "gtlt" ||
          filtersPayload.los_op === "gtelte"
        ) {
          setLosMode("range");
        }
        // Set LOS values from array
        //   if (filtersPayload.los && Array.isArray(filtersPayload.los) && filtersPayload.los.length > 0) {
        //     setLosValue(filtersPayload.los[0]?.toString() || "");
        //     if (filtersPayload.los.length > 1) {
        //       setLosToValue(filtersPayload.los[1]?.toString() || "");
        //     }
        //   }
        // }
        if (
          filtersPayload.los &&
          Array.isArray(filtersPayload.los) &&
          filtersPayload.los.length > 0
        ) {
          // Convert number/null to string
          const firstVal = filtersPayload.los[0];
          setLosValue(firstVal === null ? "no_los" : firstVal.toString());
          if (filtersPayload.los.length > 1) {
            const secondVal = filtersPayload.los[1];
            setLosToValue(secondVal === null ? "no_los" : secondVal.toString());
          }
        }
      }

      // Initialize unassigned based on current is_user_specific
      // When is_user_specific is true, unassigned should be false (and vice versa)
      // setUnassigned(filtersPayload.is_user_specific === false);
    }
  }, [show, dispatch]);


  /* =========================
     LOS HANDLERS
  ========================= */
  const handleLosOperatorChange = (selected) => {
    const operator = selected?.value || "";
    console.log("LOS operator changed to:", operator);

    setLosOperator(operator);
    setIsLosEnabled(!!operator);

    // Update los_op in Redux
    dispatch(updateUserAssginedFilters({ los_op: operator || null }));

    if (operator === "gtlt" || operator === "gtelte") {
      setLosMode("range");
    } else {
      setLosMode("single");
    }
  };

  const handleLosChange = (e) => {
    const value = e.target.value;
    console.log("LOS value changed:", value);
    setLosValue(value);

    // Update los array in Redux
    let newLosArray = [];
    if (value && value !== "") {
      // Convert to number, but keep null for 'no_los'
      const numValue = value === "no_los" ? null : parseInt(value, 10);

      if (losMode === "range") {
        const toValue = losToValue || "";
        const numToValue = toValue === "no_los" ? null : parseInt(toValue, 10);

        // Only add valid numbers (not NaN)
        if (!isNaN(numValue) || numValue === null) {
          newLosArray.push(numValue);
        }
        if (toValue !== "" && (!isNaN(numToValue) || numToValue === null)) {
          newLosArray.push(numToValue);
        }
      } else {
        // Single mode
        if (!isNaN(numValue) || numValue === null) {
          newLosArray.push(numValue);
        }
      }
    }

    dispatch(
      updateUserAssginedFilters({
        los: newLosArray,
      }),
    );
  };

  const handleLosToChange = (e) => {
    const value = e.target.value;
    console.log("LOS To value changed:", value);
    setLosToValue(value);

    // Update los array in Redux
    let newLosArray = [];

    if (losValue && losValue !== "") {
      // Convert from value
      const numFromValue =
        losValue === "no_los" ? null : parseInt(losValue, 10);

      if (losMode === "range") {
        const numToValue = value === "no_los" ? null : parseInt(value, 10);

        // Only add valid numbers (not NaN)
        if (!isNaN(numFromValue) || numFromValue === null) {
          newLosArray.push(numFromValue);
        }
        if (value !== "" && (!isNaN(numToValue) || numToValue === null)) {
          newLosArray.push(numToValue);
        }
      } else {
        // Single mode - only from value
        if (!isNaN(numFromValue) || numFromValue === null) {
          newLosArray.push(numFromValue);
        }
      }
    }

    console.log("New LOS array:", newLosArray);
    dispatch(
      updateUserAssginedFilters({
        los: newLosArray,
      }),
    );
  };
  /* =========================
     BREADCRUMB HELPERS
  ========================= */
  const breadcrumbExcludeKeys = ["page_number"];

  const labelMaps = {
    episode_identiferF: episodeIdentiferFieldOptions,
    medical_record_number: MRNFieldOptions,
    speciality: specialityFieldOptions,
    queue: queueFieldOptions,
    priority: priorityFiledOptions,
    status: filteredStatusOptions,
    los_op: losOperatorOptions,
    health_fund_contract: healthFundFieldOptions,
    drg_code: provisionalDrgFieldOptions,
  };

  const breadcrumbKeyLabels = {
    episode_identifier: "Episode Identifier",
    medical_record_number: "MRN/UR",
    drg_code: "Provisional DRG",
    health_fund_contract: "Health Fund Contract",
    priority: "Priority",
    is_user_specific: "User Specific",
  };

  const getLabel = (key, value) => {

    if (key === "is_user_specific") {
      return value ? "True" : "False";
    }
//   if (key === "queue") {
//   const queueOption = queueFilterOptions?.data?.find(
//     (q) => q.queue_id === value
//   );

//   return queueOption ? queueOption.queue_name : value;
// }

    // if (key === "medical_record_number") {
    //   if (value === "no_mrn" || value === null) {
    //     return "No MRN";
    //   }
    //   return value;
    // }
    if (key === "los" && Array.isArray(value)) {
      if (value.length === 0) return "No LOS";
      if (value.length === 1) {
        return value[0] === null ? "No LOS" : `${value[0]} days`;
      }
      // For range
      const from = value[0] === null ? "No LOS" : `${value[0]} days`;
      const to = value[1] === null ? "No LOS" : `${value[1]} days`;
      return `${from} to ${to}`;
    }
    if (key === "los_op") {
      return losOpLabelMap[value] || value;
    }
    return labelMaps[key]?.find((o) => o.value === value)?.label || value;
  };

  const getLosBreadcrumbText = (operator, losArray) => {
    console.log("getLosBreadcrumbText called with:", { operator, losArray });
    if (!operator || !losArray || losArray.length === 0) return "";

    const operatorText = losOpLabelMap[operator] || operator;

    if (losArray.length === 1) {
      return `${operatorText} ${losArray[0]} days`;
    } else if (losArray.length === 2) {
      return `${operatorText} ${losArray[0]} and ${losArray[1]} days`;
    }

    return `${operatorText} ${losArray.join(", ")}`;
  };

  const hasValue = Object?.entries(filtersPayload)?.some(
    ([key, val]) =>
      !breadcrumbExcludeKeys?.includes(key) &&
      // (Array.isArray(val) ? val.length > 0 : !!val)
      (key === "is_user_specific"
        ? val !== null && val !== undefined
        : Array.isArray(val)
          ? val.length > 0
          : val !== null && val !== ""),
  );

  //Formate Date
  const formatYYYYMMDD = (d) =>
    d
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(d.getDate()).padStart(2, "0")}`
      : null;

  const handleApply = () => {
    let losArray = [];

    if (losOperator && losValue && losValue !== "") {
      const numLosValue = losValue === "no_los" ? null : parseInt(losValue, 10);

      if (losMode === "range" && losToValue && losToValue !== "") {
        const numLosToValue =
          losToValue === "no_los" ? null : parseInt(losToValue, 10);

        if (!isNaN(numLosValue) || numLosValue === null) {
          losArray.push(numLosValue);
        }
        if (!isNaN(numLosToValue) || numLosToValue === null) {
          losArray.push(numLosToValue);
        }
      } else {
        if (!isNaN(numLosValue) || numLosValue === null) {
          losArray.push(numLosValue);
        }
      }
    }

    console.log("LOS array (numbers):", losArray);

    const payload = {
      ...filtersPayload,
      page_number: 1,
      los_op: losOperator || null,
      los: losArray,
      is_user_specific: isUserSpecific,
    };

    console.log("Final payload to send:", payload);



    const { page_number, ...rest } = payload;
    const updatedFiltersWithQueuePage = {
      ...rest,
      queue_page_number: 1,
    };
    setLosOperator("");
    setLosValue("");
    setLosOperator("");
    setLosToValue("")
    dispatch(fetchCodersData(payload));
    dispatch(getCoderViewCards(payload));
    dispatch(fetchStatsData(payload));
    dispatch(getCoderSidebarQueues())
    setShowCoderFilter(false);
    dispatch(updateUserAssginedFilters(payload))
    setCoderSearchTerm("")
  };
  const handleReset = () => {
    setLosOperator("");
    setLosValue("");
    setLosToValue("");
    setIsLosEnabled(false);
    setLosMode("single");
    setFirstQueueTypeWhenUnassigned(null);
    // setUnassigned(false); // Reset unassigned to false

    const resetState = {
      separation_date_from: null,
        separation_date_to: null,
        admission_date_from: null,
        admission_date_to: null,
        speciality: [],
        queue: [],
        status: [],
        page_number: 1,
        // page_size: 10,
        priority: [],
        medical_record_number: [],
        episode_identifier: [],
        health_fund_contract: [],
        los: [],
        los_op: "",
        drg_code: [],
        is_user_specific: true,
        sort_by: [],
        sort_order: [],
    };

    dispatch(updateUserAssginedFilters(resetState));
  };

  /* =========================
     UI
  ========================= */
  return (
    <Modal
      show={show}
      onHide={() => {
        setLosOperator("");
    setLosValue("");
    setLosOperator("");
    setLosToValue("")
    onClose()
      }}
      backdrop="static"
      dialogClassName="modal-xl"
    >
      <Modal.Header closeButton className="episode-list-modal-header">
        <Modal.Title className="episode-list-filter-modal-title">
         Coder Workspace Filters
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {hasValue && (
          <div className="episodelist-filter-breadcrumb-section">
            <div className="episodelist-breadcrumb-list">
              {/* Show unassigned in breadcrumbs (UI only) */}
              {/* {unassigned && (
                <Badge
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  unassigned : True
                  <img
                    src={closeIcon}
                    className="episodeListFilterObj-close-icon"
                    onClick={() => setUnassigned(false)}
                  />
                </Badge>
              )} */}

              {Object.entries(filtersPayload)
                .filter(([key]) => !breadcrumbExcludeKeys.includes(key))
                .map(([key, value]) => {
                  if (
                    key !== "is_user_specific" &&
                    (!value || (Array.isArray(value) && value.length === 0))
                  )
                    return null;

                  // Handle date objects - format them properly
                  if (
                    key === "separation_date_from" ||
                    key === "separation_date_to" ||
                    key === "admission_date_from" ||
                    key === "admission_date_to"
                  ) {
                    const [y, m, d] = value.split("-");

                    return (
                      <Badge
                        key={key}
                        className="episodeListFilterObj-breadcrumbItem"
                      >
                        {key.replace(/_/g, " ")} : {`${d}/${m}/${y}`}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon"
                          onClick={() =>
                            dispatch(updateUserAssginedFilters({ [key]: null }))
                          }
                        />
                      </Badge>
                    );
                  }

                  if (Array.isArray(value)) {
                    return value.map((item) => (
                      <Badge
                        key={`${key}-${item}`}
                        className="episodeListFilterObj-breadcrumbItem"
                      >
                        {key.replace(/_/g, " ")} : {getLabel(key, item)}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon"
                          onClick={() =>
                            dispatch(
                              updateUserAssginedFilters({
                                [key]: value.filter((v) => v !== item),
                              }),
                            )
                          }
                        />
                      </Badge>
                    ));
                  }

                  if (Array.isArray(value)) {
                    return value.map((item) => (
                      <Badge
                        key={`${key}-${item}`}
                        className="episodeListFilterObj-breadcrumbItem"
                      >
                        {breadcrumbKeyLabels[key] || key.replace(/_/g, " ")} :{" "}
                        {getLabel(key, item)}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon"
                          onClick={() =>
                            dispatch(
                              updateUserAssginedFilters({
                                [key]: value.filter((v) => v !== item),
                              }),
                            )
                          }
                        />
                      </Badge>
                    ));
                  }

                  if (key === "is_user_specific") {
                    return (
                      <Badge
                        key={key}
                        className="episodeListFilterObj-breadcrumbItem"
                      >
                        User Specific : {value ? "True" : "False"}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon"
                          onClick={() =>
                            dispatch(
                              updateUserAssginedFilters({
                                is_user_specific: true,
                              }),
                            )
                          }
                        />
                      </Badge>
                    );
                  }

                  // Handle LOS breadcrumbs
                  if (key === "los_op" && value) {
                    const losArray = filtersPayload.los || [];
                    const displayText = getLosBreadcrumbText(value, losArray);

                    return (
                      <Badge
                        key={key}
                        className="episodeListFilterObj-breadcrumbItem"
                      >
                        LOS : {displayText}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon"
                          onClick={() => {
                            dispatch(
                              updateUserAssginedFilters({
                                [key]: null,
                                los: [],
                              }),
                            );
                            setIsLosEnabled(false);
                            setLosMode("single");
                          }}
                        />
                      </Badge>
                    );
                  }

                  // Handle other single values
                  return (
                    <Badge
                      key={key}
                      className="episodeListFilterObj-breadcrumbItem"
                    >
                      {key.replace(/_/g, " ")} : {getLabel(key, value)}
                      <img
                        src={closeIcon}
                        className="episodeListFilterObj-close-icon"
                        onClick={() =>
                          dispatch(updateUserAssginedFilters({ [key]: "" }))
                        }
                      />
                    </Badge>
                  );
                })}
            </div>

            <Button className="episodelist-reset-btn" onClick={handleReset}>
              Clear All
            </Button>
          </div>
        )}

        <div
          className="workflow-him-filter-container"
          style={{
            gridTemplateColumns:
              losMode === "range"
                ? "repeat(3, minmax(0, 1fr))"
                : "repeat(3, minmax(0, 1fr))",
          }}
        >
          {/* Episode Id */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Episode Identifier
            </label>
            <MultiSelect
            isMulti={true}
              options={episodeIdentiferFieldOptions}
              isLoading={episodeIdentiferFilterOptions.loading}
              hasMore={episodeIdentiferFilterOptions.hasMore}
              placeholder="Search episode identifer"
              onScrollBottom={handleScrollBottom(
                episodeIdentiferFilterOptions,
                getEpisodeIdentiferFilterOptions,
              )}
              onInputChange={handleInputChange(
                setEpisodeIdentiferFilterSearch,
                getEpisodeIdentiferFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  episodeIdentiferFilterOptions,
                  getEpisodeIdentiferFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("episodeIdentiferFilterOptions", setEpisodeIdentiferFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "episode_identifier",
                  selected,
                  optionsState: episodeIdentiferFilterOptions,
                  fetchThunk: getEpisodeIdentiferFilterOptions,
                  searchResetAction: setEpisodeIdentiferFilterSearch,
                });
              }}
              value={episodeIdentiferFieldOptions?.filter((o) =>
                filtersPayload.episode_identifier?.includes(o?.value),
              )}
            />
          </div>
          {/* UR Number */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">MRN/UR</label>
            <MultiSelect
              isMulti={true}
              options={MRNFieldOptions}
              isLoading={MRNFilterOptions.loading}
              hasMore={MRNFilterOptions.hasMore}
              placeholder="Search MRN"
              onScrollBottom={handleScrollBottom(
                MRNFilterOptions,
                getMRNFilterOptions,
              )}
              onInputChange={handleInputChange(
                setMRNFilterSearch,
                getMRNFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(MRNFilterOptions, getMRNFilterOptions);
              }}
              onBlur={handleResetOnBlur("MRNFilterOptions", setMRNFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "medical_record_number",
                  selected,
                  optionsState: MRNFilterOptions,
                  fetchThunk: getMRNFilterOptions,
                  searchResetAction: setMRNFilterSearch,
                });
              }}
              value={MRNFieldOptions.filter((o) =>
                filtersPayload.medical_record_number.includes(o.value),
              )}
            />
          </div>
          {/* Admission From */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Admission Date From
            </label>
            <DatePicker
              selected={
                filtersPayload.admission_date_from
                  ? new Date(filtersPayload.admission_date_from)
                  : null
              }
              onChange={(date) =>
                dispatch(
                  updateUserAssginedFilters({
                    admission_date_from: formatYYYYMMDD(date),
                    admission_date_to:
                      !date ||
                      (filtersPayload.admission_date_to &&
                        new Date(filtersPayload.admission_date_to) < date)
                        ? null
                        : filtersPayload.admission_date_to,
                  }),
                )
              }
              className="workflow-coderview-filter-date-picker"
              dateFormat="dd/MM/yyyy"
              placeholderText=" Admission Date From"
              showMonthDropdown
              showYearDropdown
              maxDate={new Date()}
              dropdownMode="select"
              onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
            />
          </div>
          {/* Admission To */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Admission Date To
            </label>
            <div
              className={`${
                !filtersPayload.admission_date_from ? "datepicker-tooltip" : ""
              }`}
              data-title={
                "'To date' cannot be selected until 'Admission from date' is selected"
              }
            >
              <DatePicker
                selected={
                  filtersPayload.admission_date_to &&
                  filtersPayload.admission_date_from
                    ? new Date(filtersPayload.admission_date_to)
                    : null
                }
                onChange={(d) =>
                  dispatch(
                    updateUserAssginedFilters({
                      admission_date_to: formatYYYYMMDD(d),
                    }),
                  )
                }
                className="workflow-coderview-filter-date-picker"
                dateFormat="dd/MM/yyyy"
                placeholderText=" Admission Date To"
                disabled={!filtersPayload.admission_date_from}
                showMonthDropdown
                showYearDropdown
                maxDate={new Date()}
                dropdownMode="select"
                minDate={filtersPayload?.admission_date_from ?? null}
                onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
              />
            </div>
          </div>

          {/* From Date */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Separation Date From
            </label>
            <DatePicker
              selected={
                filtersPayload.separation_date_from
                  ? new Date(filtersPayload.separation_date_from)
                  : null
              }
              onChange={(date) =>
                dispatch(
                  updateUserAssginedFilters({
                    separation_date_from: formatYYYYMMDD(date),
                    separation_date_to:
                      !date ||
                      (filtersPayload.separation_date_to &&
                        new Date(filtersPayload.separation_date_to) < date)
                        ? null
                        : filtersPayload.separation_date_to,
                  }),
                )
              }
              className="workflow-coderview-filter-date-picker"
              dateFormat="dd/MM/yyyy"
              placeholderText="Separation Date From"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              maxDate={new Date()}
              minDate={
                filtersPayload?.admission_date_from ??
                filtersPayload?.admission_date_from
              }
              onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
            />
          </div>

          {/* To Date */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Separation Date To
            </label>
            <div
              className={`${
                !filtersPayload.admission_date_from ? "datepicker-tooltip" : ""
              }`}
              data-title={
                "'To date' cannot be selected until 'Separation from date' is selected"
              }
            >
              <DatePicker
                selected={
                  filtersPayload.separation_date_to &&
                  filtersPayload.separation_date_from
                    ? new Date(filtersPayload.separation_date_to)
                    : null
                }
                onChange={(d) =>
                  dispatch(
                    updateUserAssginedFilters({
                      separation_date_to: formatYYYYMMDD(d),
                    }),
                  )
                }
                className="workflow-coderview-filter-date-picker"
                dateFormat="dd/MM/yyyy"
                placeholderText="Separation Date To"
                disabled={!filtersPayload.separation_date_from}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={filtersPayload?.separation_date_from}
                maxDate={new Date()}
                onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
              />
            </div>
          </div>
          {/* Speciality */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Speciality</label>
            <MultiSelect
              isMulti={true}
              options={specialityFieldOptions}
              isLoading={specialityFilterOptions.loading}
              hasMore={specialityFilterOptions.hasMore}
              placeholder="Search speciality"
              onScrollBottom={handleScrollBottom(
                specialityFilterOptions,
                getSpecialityFilterOptions,
              )}
              onInputChange={handleInputChange(
                setSpecialityFilterSearch,
                getSpecialityFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  specialityFilterOptions,
                  getSpecialityFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("specialityFilterOptions", setSpecialityFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "speciality",
                  selected,
                  optionsState: specialityFilterOptions,
                  fetchThunk: getSpecialityFilterOptions,
                  searchResetAction: setSpecialityFilterSearch,
                });
              }}
              value={specialityFieldOptions.filter((o) =>
                filtersPayload.speciality.includes(o.value),
              )}
            />
          </div>
          {/* Queue */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Queue</label>

            <MultiSelect
              isMulti={true}
              options={queueFieldOptions}
              isLoading={queueFilterOptions.loading}
              hasMore={queueFilterOptions.hasMore}
              placeholder={
                isQueueDisabled
                  ? "Set User Specific to False to enable Queue"
                  : "Select Queue"
              }
              isDisabled={isQueueDisabled}
              onScrollBottom={handleScrollBottom(
                queueFilterOptions,
                getQueueFilterOptions,
              )}
              onInputChange={handleInputChange(
                setQueueFilterSearch,
                getQueueFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(queueFilterOptions, getQueueFilterOptions);
              }}
              onBlur={handleResetOnBlur("queueFilterOptions", setQueueFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "queue",
                  selected,
                  optionsState: queueFilterOptions,
                  fetchThunk: getQueueFilterOptions,
                  searchResetAction: setQueueFilterSearch,
                });
              }}
              value={queueFieldOptions.filter((o) =>
                filtersPayload.queue.includes(o.value),
              )}
            />
          </div>

          {/* Unassigned */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">User Specific</label>
            {/* <UnassignedSelect /> */}
            <Select
              options={userSpecificOptions}
              value={userSpecificOptions.find(
                (o) => o.value === isUserSpecific,
              )}
              isSearchable={false}
              isClearable={false}
              // menuPortalTarget={document.body}
              // styles={{
              //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              //   menu: (base) => ({ ...base, zIndex: 9999 }),
              //   control: (base) => ({
              //     ...base,
              //     minHeight: "38px",
              //     borderColor: "#cfd6e4",
              //   }),
              // }}
              // menuPosition="fixed"
              onChange={(selected) => {
                const value = selected?.value ?? true;
                dispatch(
                  updateUserAssginedFilters({
                    is_user_specific: value,
                    ...(value === true && { queue: [] }),
                  }),
                );
              }}
            />
          </div>
          {/* Priority */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Priority</label>
            <MultiSelect
              isMulti={true}
              options={priorityFiledOptions}
              isLoading={priorityFilterOptions.loading}
              hasMore={priorityFilterOptions.hasMore}
              placeholder="Search Priority"
              onScrollBottom={handleScrollBottom(
                priorityFilterOptions,
                getPriorityFilterOptions,
              )}
              onInputChange={handleInputChange(
                setPriorityFilterSearch,
                getPriorityFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(priorityFilterOptions, getPriorityFilterOptions);
              }}
              onBlur={handleResetOnBlur("priorityFilterOptions", setPriorityFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "priority",
                  selected,
                  optionsState: priorityFilterOptions,
                  fetchThunk: getPriorityFilterOptions,
                  searchResetAction: setPriorityFilterSearch,
                });
              }}
              value={priorityFiledOptions.filter((o) =>
                filtersPayload?.priority?.includes(o?.value),
              )}
            />
          </div>
          {/* Status */}
          <div className="workflow-him-filter-card flex flex-column">
            <div
              style={{
                marginTop: isUserSpecific === false ? "32px" : "0px",
              }}
            >
              <label className="workflow-him-filter-label">Status</label>

              <MultiSelect
                isMulti={true}
                options={filteredStatusOptions}
                isLoading={statusFilterOptions.loading}
                hasMore={statusFilterOptions.hasMore}
                placeholder="Search Status"
                onScrollBottom={handleScrollBottom(
                  statusFilterOptions,
                  getStatusFilterOptions,
                )}
                onInputChange={handleInputChange(
                  setStatusFilterSearch,
                  getStatusFilterOptions,
                )}
                onFocus={() => {
                  handleOnFocus(statusFilterOptions, getStatusFilterOptions);
                }}
                onBlur={handleResetOnBlur("statusFilterOptions", setStatusFilterSearch)}
                onChange={(selected) => {
                  handleOnChange({
                    key: "status",
                    selected,
                    optionsState: statusFilterOptions,
                    fetchThunk: getStatusFilterOptions,
                    searchResetAction: setStatusFilterSearch,
                  });
                }}
                value={filteredStatusOptions?.filter((o) =>
                  filtersPayload.status?.includes(o?.value),
                )}
              />
            </div>
            {isUserSpecific === false && (
              <small className="text-info">
                Set User Specific to true to see all the status
              </small>
            )}
          </div>
          {/* Health Fund Contract */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Health Fund Contract
            </label>
            <MultiSelect
              isMulti={true}
              options={healthFundFieldOptions}
              isLoading={healthFundContractFilterOptions.loading}
              hasMore={healthFundContractFilterOptions.hasMore}
              placeholder="Search Health Fund Contract"
              onScrollBottom={handleScrollBottom(
                healthFundContractFilterOptions,
                getHealthFundContractFilterOptions,
              )}
              onInputChange={handleInputChange(
                setHealthFundFilterContractSearch,
                getHealthFundContractFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  healthFundContractFilterOptions,
                  getHealthFundContractFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("healthFundContractFilterOptions", setHealthFundFilterContractSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "health_fund_contract",
                  selected,
                  optionsState: healthFundContractFilterOptions,
                  fetchThunk: getHealthFundContractFilterOptions,
                  searchResetAction: setHealthFundFilterContractSearch,
                });
              }}
              value={healthFundFieldOptions.filter((o) =>
                filtersPayload.health_fund_contract.includes(o.value),
              )}
            />
          </div>

          {/* LOS Operator */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">LOS Operator</label>
            <Select
              className="los-operator"
              options={losOperatorOptions}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                  ...base,
                  minHeight: "38px",
                  borderColor: "#cfd6e4",
                }),
              }}
              placeholder="Select operator"
              value={
                losOperator
                  ? losOperatorOptions.find((o) => o.value === losOperator)
                  : null
              }
              onChange={handleLosOperatorChange}
            />
          </div>

          {/* LOS Value */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              {losMode === "range" ? "LOS From" : "Length of Stay (LOS)"}
            </label>
            <div
              className={`${
                !filtersPayload.los_op ? "datepicker-tooltip" : ""
              }`}
              data-title={"Select LOS operator to enable"}
            >
              <input
                type="number"
                min="1"
                className="form-control"
                value={losValue}
                onChange={handleLosChange}
                placeholder={
                  losMode === "range" ? "Enter minimum LOS" : "Enter LOS"
                }
                disabled={!isLosEnabled}
                style={{
                  minHeight: "38px",
                  borderColor: "#cfd6e4",
                  backgroundColor: !isLosEnabled ? "#f3f4f6" : "white",
                  opacity: !isLosEnabled ? 0.7 : 1,
                }}
              />
            </div>
          </div>

          {/* LOS To (for range mode) */}
          {losMode === "range" && (
            <div className="workflow-him-filter-card">
              <label className="workflow-him-filter-label">LOS To</label>
              <input
                type="number"
                min="1"
                className="form-control"
                value={losToValue}
                onChange={handleLosToChange}
                placeholder="Enter maximum LOS"
                disabled={!isLosEnabled}
                style={{
                  minHeight: "38px",
                  borderColor: "#cfd6e4",
                  backgroundColor: !isLosEnabled ? "#f3f4f6" : "white",
                  opacity: !isLosEnabled ? 0.7 : 1,
                }}
              />
            </div>
          )}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Provisional DRG</label>
            <MultiSelect
              isMulti={true}
              options={provisionalDrgFieldOptions}
              isLoading={provisionalDrgFilterOptions.loading}
              hasMore={provisionalDrgFilterOptions.hasMore}
              placeholder="Search DRG"
              onScrollBottom={handleScrollBottom(
                provisionalDrgFilterOptions,
                getProvisionalDrgFilterOptions,
              )}
              onInputChange={handleInputChange(
                setProvisionalDrgFilterSearch,
                getProvisionalDrgFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  provisionalDrgFilterOptions,
                  getProvisionalDrgFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("provisionalDrgFilterOptions", setProvisionalDrgFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "drg_code",
                  selected,
                  optionsState: provisionalDrgFilterOptions,
                  fetchThunk: getProvisionalDrgFilterOptions,
                  searchResetAction: setProvisionalDrgFilterSearch,
                });
              }}
              value={provisionalDrgFieldOptions.filter((o) =>
                filtersPayload.drg_code.includes(o.value),
              )}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="episode-list-filter-modal-footer">
        <Button
          className="el-filter-cancel btn btn-secondary"
          onClick={() => {
            setLosOperator("");
            setLosValue("");
            setLosOperator("");
            setLosToValue("");
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button
          className="el-filter-submit btn btn-primary"
          onClick={handleApply}
        >
          Apply
        </Button>
      </Modal.Footer>
      <ToastContainer position="top-right" autoClose={3000} />
    </Modal>
  );
};

export default CoderFilterModal;
